<template>
<div class="toast align-items-center tt" :class="showClass" role="alert" aria-live="assertive" aria-atomic="true">
  <div class="d-flex">
    <div class="toast-body">
      {{ text }}
    </div>
    <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
  </div>
</div>
</template>

<script setup>
import { ref, defineExpose } from 'vue'

const interval = ref()
const showClass = ref('')
const text = ref('')

defineExpose({
    showToolTip,
});

async function startTimer() {
    interval.value = setInterval(() => {
        showClass.value = '' 
        clearInterval(interval.value)
    }, 3*1000);
}

function showToolTip(t) {
    text.value = t
    showClass.value = 'show'
    startTimer()
}

// onMounted(() => {
//     showToolTip('test tekst')
// })

</script>

<style scoped>

.tt {
    position: fixed;
    top: 20px;
    right: 30px;
    z-index: 99;
    color: #000;
}

</style>
